import { useState, useEffect, useMemo } from "react";
import { useAppStore } from "../store/store";
import useGetApi from "../util/useGetApi";

export default function useRecommendedPortfolio({
  callback = null,
  isRtq = false,
}) {
  const portfolios = useAppStore((state) => state.formOptions.portfolios);
  const [recommendedPortfolio, setRecommendedPortfolio] = useState("");
  const [recommendedPortfolioInfo, setRecommendedPortfolioInfo] = useState("");
  const {
    getRecommendedPortfolioGb,
    getRecommendedPortfolioRtq,
    loading: APILoading,
  } = useGetApi();
  const [recommendedLoading, setRecommendedLoading] = useState(false);
  const loading = useMemo(
    () => APILoading || recommendedLoading,
    [APILoading, recommendedLoading],
  );

  // Internal helper function to get recommended portfolio
  async function getRecommended() {
    try {
      // Use the appropriate API method based on whether it's RTQ or GB
      const getRecommendedMethod = isRtq
        ? getRecommendedPortfolioRtq
        : getRecommendedPortfolioGb;

      // Call the API to get recommended portfolio
      const recommended = await getRecommendedMethod();

      console.log("API Response from getRecommended:", recommended);

      // Get all portfolios from the store
      let portfoliosList = portfolios;
      if (!portfoliosList || portfoliosList?.length < 1) {
        return {
          recommended: recommended,
          matchedPortfolio: { name: "Default Portfolio", code: "" },
        };
      }

      // Find the portfolio that matches what we got back from the API
      // First check if we have a recommendedPortfolioId from the API
      const portfolioId = recommended.recommendedPortfolioId || recommended.id;

      console.log("Looking for portfolio with ID:", portfolioId);
      console.log("Available portfolios:", portfoliosList);

      // Try to find portfolio by ID first (from the get-recommended endpoint)
      let matchedPortfolio = portfoliosList?.find((p) => p.id === portfolioId);

      // If not found by ID, try to find by code (legacy approach)
      if (!matchedPortfolio && recommended.code) {
        console.log(
          "Portfolio not found by ID, trying code:",
          recommended.code,
        );
        matchedPortfolio = portfoliosList?.find(
          (p) => p.code === recommended.code,
        );
      }

      console.log("Selected portfolio:", matchedPortfolio);

      return {
        recommended,
        matchedPortfolio,
      };
    } catch (err) {
      console.error("Error in getRecommended:", err);

      return null;
    }
  }

  useEffect(() => {
    console.log("useRecommendedPortfolio useEffect triggered, isRtq:", isRtq);
    async function fetchData() {
      setRecommendedLoading(true);
      try {
        const result = await getRecommended();
        console.log("Recommended portfolio result:", result);
        if (result) {
          const { recommended, matchedPortfolio } = result;
          setRecommendedPortfolio(recommended);
          setRecommendedPortfolioInfo(matchedPortfolio);
          if (callback) callback();
        }
      } catch (error) {
        console.error("Error fetching recommended portfolio:", error);
      } finally {
        setRecommendedLoading(false);
      }
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRtq]);

  return { recommendedPortfolio, recommendedPortfolioInfo, loading };
}
